import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../FirmSettings.meta';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { useFeatureFlag } from '../../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../../CommonSelectors/CommonArea.types';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const PulseCheck = ({ formBag, ...rest }: Props) => {
  const showPulseCheck = useFeatureFlag(Feature.PulseCheck);

  if (!showPulseCheck) {
    return null;
  }

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="PulseCheck" />

      <Toggle {...formBag.register('allowPulseCheck')} mt="24">
        Allow Advisors to Access PulseCheck
      </Toggle>
    </Box>
  );
};
